import { Select } from "antd";

export interface TypeData {
  value: string | boolean | number;
  label: string | boolean | number;
}

function ActionDropdown({
  value,
  options,
  onChange,
  placeholder,
}: {
  value: any;
  options: TypeData[];
  onChange: (e: string) => void;
  placeholder: string;
}) {
  const formattedOptions = options?.map((item: TypeData) => ({
    value: item.value, 
    label: item.label, 
  }));

  return (
    <Select
      showSearch
      value={value !== "" && value !== undefined && value !== null ? value : null}   
      filterOption={(input, option: any) =>
        option?.label?.toLowerCase()?.includes(input?.toLowerCase())
      }
      onChange={onChange}
      className="w-40"
      placeholder={placeholder}
      allowClear
      options={formattedOptions} 
    />
  );
}

export default ActionDropdown;
